import React from 'react';

const TERMS_TEXT = `Last updated: May 2026

1. Acceptance of Terms

By creating an account or using the Lead Scoring SaaS service ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.

2. Description of Service

The Service provides AI-assisted lead scoring, CRM integration, and sales analytics tools for sales teams. Features include manual and CSV lead upload, Claude-powered lead analysis, HubSpot and Typeform integrations, and daily email digests.

3. Free Tier Limits

Free accounts are limited to 50 leads per calendar month. This limit is enforced automatically. Exceeding the limit will prevent new lead creation until the next billing period begins.

4. User Accounts

You are responsible for maintaining the confidentiality of your account credentials. You are responsible for all activity that occurs under your account. Notify us immediately if you suspect unauthorized access.

5. Acceptable Use

You agree not to:
• Upload lead data you do not have the right to process
• Attempt to reverse-engineer, scrape, or abuse the API
• Use the Service to send spam or engage in any unlawful activity
• Share your account credentials with third parties

6. Data Ownership

You retain ownership of all data you upload to the Service. By using the Service, you grant us a limited license to process that data solely to provide the Service to you.

7. Intellectual Property

The Service, including its software, design, and AI models, is owned by us and protected by intellectual property laws. You may not copy, modify, or distribute any part of the Service without our written permission.

8. Third-Party Integrations

The Service integrates with third-party platforms including HubSpot and Typeform. Your use of those platforms is governed by their respective terms of service. We are not responsible for third-party platform outages or changes.

9. Disclaimers

THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. AI-generated lead scores are predictions, not guarantees. We do not warrant that the Service will be uninterrupted or error-free.

10. Limitation of Liability

TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE.

11. Termination

We may suspend or terminate your account at any time for violation of these Terms. You may close your account at any time by contacting support.

12. Changes to Terms

We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the revised Terms.

13. Contact

For questions about these Terms, contact us at support@lead-scoring-saas.com.`;

export default function Terms() {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
            <div className="prose prose-gray max-w-none mt-6">
                {TERMS_TEXT.split('\n\n').map((block, i) => {
                    if (/^\d+\./.test(block.trim())) {
                        const [heading, ...rest] = block.split('\n');
                        return (
                            <div key={i} className="mb-6">
                                <h2 className="text-lg font-semibold text-gray-800 mb-2">{heading}</h2>
                                {rest.length > 0 && (
                                    <p className="text-gray-600 leading-relaxed whitespace-pre-line">{rest.join('\n')}</p>
                                )}
                            </div>
                        );
                    }
                    return (
                        <p key={i} className="text-gray-600 leading-relaxed mb-4 whitespace-pre-line">
                            {block}
                        </p>
                    );
                })}
            </div>
        </div>
    );
}
